import type { TranslationKey } from "./en";

export const zhTW: Record<TranslationKey, string> = {
  "language.label": "語言",

  "nav.signOut": "登出",
  "nav.breadcrumb": "導覽路徑",
  "nav.classrooms": "班級",
  "nav.schools": "學校",
  "nav.sidebar": "教師導覽",
  "nav.openMenu": "開啟選單",
  "nav.closeMenu": "關閉選單",
  "nav.books": "教材",
  "nav.assignHomework": "指派作業",
  "nav.checkHomework": "批改作業",
  "nav.selfStudyRecord": "自主學習紀錄",

  "common.back": "返回",
  "common.tryAgain": "再試一次",
  "common.cancel": "取消",
  "common.done": "完成",
  "common.clearAll": "全部清除",
  "common.selectAll": "全選",
  "common.delete": "刪除",

  "home.welcome": "{name}，歡迎回來",
  "home.books": "教材",
  "home.books.caption": "瀏覽所有可指派的專案與課程。",
  "home.classrooms": "班級",
  "home.classrooms.caption": "你的班級與學生。",

  "books.title": "教材",

  "classrooms.title": "班級",
  "classrooms.loadError": "無法從 MyBestUser 載入你的班級。",
  "classrooms.studentCount": "{count} 位學生",
  "classrooms.empty": "你目前沒有任教的班級。",
  "classroom.fallbackName": "班級",

  "check.tabHomework": "作業",
  "check.column.title": "作業",
  "check.column.due": "截止日",
  "check.column.assigned": "指派日",
  "check.column.classroom": "班級",
  "check.empty": "您尚未指派任何作業。",
  "check.loadError": "無法載入您指派的作業。",

  "roster.title": "學生",
  "roster.loadError": "無法載入這份名單。",
  "roster.enrolled": "{count} 位在校",
  "roster.neverSignedIn": "尚未登入過",
  "roster.empty": "這個班級還沒有學生。",

  "student.fallbackName": "學生",
  "student.homework": "作業",
  "student.homeworkLoadError": "無法載入這位學生的作業。",
  "student.completed": "已完成",
  "student.onTime": "準時",
  "student.overdue": "逾期",
  "student.report": "學習報告",
  "student.score": "自主學習紀錄",
  "student.reportLoadError": "無法載入這位學生的學習報告。",
  "student.nextFocus": "待加強",
  "student.streak": "連續紀錄",
  "student.streakDayOne": "{count} 天",
  "student.streakDayOther": "{count} 天",

  "homework.listLoadError": "無法載入這份作業。",
  "homework.listEmpty": "尚未指派任何作業給這位學生。",
  "homework.completedOfTotal": "已完成 {completed}/{total}",
  "homework.submitted": "繳交於",
  "homework.due": "截止",
  "homework.progress": "進度",
  "homework.reassign": "重新指派",
  "homework.deleteConfirm": "要刪除「{title}」嗎？{warning}此動作無法復原。",
  "homework.deleteWarning": "學生已完成的部分仍會保留在學習紀錄中。",
  "homework.deleted": "作業已刪除",
  "homework.deleteFailed": "無法刪除作業",
  "homework.fallbackTitle": "作業",
  "homework.detailLoadError": "無法載入這份作業。",

  "homework.status.done": "已完成",
  "homework.status.overdue": "逾期",
  "homework.status.undone": "未完成",
  "homework.status.late": "遲交",

  "review.assigned": "指派於 {date}",
  "review.started": "開始於 {date}",
  "review.submitted": "繳交於 {date}",
  "review.lastPlayed": "最後練習 {date}",
  "review.dueOn": "截止 {date}",
  "review.slidesDone": "{completed}/{total} 張",
  "review.score": "分數",
  "review.slideCount": "{count} 張",
  "review.played": "已練習",
  "review.previousSlide": "上一張",
  "review.nextSlide": "下一張",
  "review.slideOfTotal": "第 {current} / {total} 張",
  "review.pauseAutoplay": "暫停自動播放",
  "review.playInOrder": "依序播放",
  "review.every": "每",
  "review.seconds": "秒",
  "review.noSlides": "這份作業已經沒有任何題目。",
  "review.notPlayed": "這份作業的這一題還沒有練習過。",
  "review.slideLocation": "題目位置",

  "assign.title": "指派作業",
  "assign.pickClassroom": "選擇要指派的班級。",
  "assign.submit": "指派",
  "assign.assigned": "已指派給 {count} 位學生",
  "assign.failed": "無法指派作業",
  "assign.titleLabel": "名稱",
  "assign.titlePlaceholder": "第三週練習",
  "assign.dueLabel": "截止日",
  "assign.slides": "題目",
  "assign.slideCount": "{count} 張",
  "assign.fromLessonOne": "{count} 張，來自 {lessons} 個課程",
  "assign.fromLessonOther": "{count} 張，來自 {lessons} 個課程",
  "assign.chooseSlides": "選擇題目",
  "assign.noSlides": "尚未選擇題目。開啟選擇器瀏覽課程，並預覽每一張的樣子。",
  "assign.subslideCount": "+{count} 張子題",
  "assign.removeSlide": "移除 {name}",
  "assign.students": "學生",
  "assign.selectedCount": "已選 {count} 位",
  "assign.pickStudentsFirst": "請先選擇學生，可選的題目取決於他們。",
  "assign.dot.blocked": "MBU 票券不包含此產品",
  "assign.dot.absent": "從未登入",
  "assign.dot.unverified": "無法連線 MyBestUser，改用最後一次登入紀錄",
  "assign.hint.notSignedIn": "尚未登入過",
  "assign.hint.checking": "正在檢查 MBU 票券…",
  "assign.hint.notCovered": "他們的 MBU 票券未涵蓋 {missing}",
  "assign.hint.unverified": "{username} · 票券未驗證",

  "library.root": "教材庫",
  "library.loadError": "無法載入教材庫的這個部分。",
  "library.itemOne": "{count} 個項目",
  "library.itemOther": "{count} 個項目",
  "library.slideOne": "{count} 張",
  "library.slideOther": "{count} 張",
  "library.empty": "這個資料夾是空的。",
  "library.truncated": "各類別僅顯示前 {count} 筆。開啟資料夾以縮小範圍。",
  "library.reach.noProduct": "專案未設定產品",
  "library.reach.studentNoProduct": "學生票券不含此產品",
  "library.reach.studentLevelTooLow": "學生等級不足",

  "picker.allGroups": "所有群組",
  "picker.allTags": "所有標籤",
  "picker.allTemplates": "所有版型",
  "picker.filterByGroup": "依群組篩選",
  "picker.filterByTag": "依標籤篩選",
  "picker.filterByTemplate": "依版型篩選",
  "picker.search": "搜尋題目",
  "picker.selectVisible": "選取這 {count} 張",
  "picker.deselectVisible": "取消選取",
  "picker.noMatches": "沒有符合這些篩選條件的題目。",

  "lesson.fallbackName": "課程",
  "lesson.slidesLoadError": "無法載入這些題目。",
  "lesson.empty": "這個課程還沒有任何題目。",
  "lesson.slideOne": "{count} 張",
  "lesson.slideOther": "{count} 張",

  "slide.fallbackName": "題目",
  "slide.notFoundTitle": "找不到這一張",
  "slide.notFoundBody": "這一張不存在或已被移除。",
  "slide.position": "第 {current} / {total} 張",
  "slide.previous": "上一張",
  "slide.next": "下一張",
  "slide.gridItem": "{name}，第 {number} 張",
  "slide.playsWith": "與這張一起播放",

  "report.performance.title": "表現",
  "report.performance.band0": "繼續加油",
  "report.performance.band1": "開始得不錯",
  "report.performance.band2": "穩定進步中",
  "report.performance.band3": "表現很好！",
  "report.performance.band4": "火力全開！",
  "report.performance.subLow": "多練習來點燃你的火焰。",
  "report.performance.subMid": "持續練習讓火焰更旺。",
  "report.performance.subHigh": "你的火焰正熊熊燃燒！",

  "report.skill.speaking": "口說",
  "report.skill.listening": "聽力",
  "report.skill.reading": "閱讀",
  "report.skill.grammar": "文法",
  "report.skill.writing": "寫作",
  "report.skill.wordRecognition": "詞彙",

  "report.insights.title": "學習洞察",
  "report.insights.areaToImprove": "待加強項目",
  "report.insights.strongestSkill": "最強項目",
  "report.insights.locked": "練習量還不足以判斷",

  "report.skills.title": "能力分析",
  "report.skills.locked": "練習量還不足以評分",
  "report.skills.provisional": "目前的練習量還很少",
  "report.skills.footnote": "多加練習以提高準確度",

  "report.duration.minutes": "{count} 分鐘",
  "report.duration.hoursMinutes": "{hours} 小時 {minutes} 分",
  "report.duration.hours": "{hours} 小時",

  "report.streak.header": "連續紀錄與進度",
  "report.streak.current": "連續 {count} 天",
  "report.streak.none": "目前沒有連續紀錄",
  "report.streak.noneYet": "尚無連續紀錄",
  "report.streak.bestOne": "最佳：{count} 天",
  "report.streak.bestOther": "最佳：{count} 天",
  "report.streak.achievement": "{current} / {threshold} 天",

  "report.activity.thisMonth": "本月",
  "report.activity.minPerDay": "每天 {count} 分鐘",
  "report.activity.previousMonth": "上個月",
  "report.activity.nextMonth": "下個月",
  "report.activity.previousYear": "前一年",
  "report.activity.nextYear": "後一年",

  "report.day.noPractice": "沒有練習紀錄",
  "report.day.timeUnavailable": "已記錄活動，但無法取得練習時間",
  "report.day.minutesPracticed": "練習 {count} 分鐘",
  "report.day.hoursMinutesPracticed": "練習 {hours} 小時 {minutes} 分",
  "report.day.hoursPracticed": "練習 {hours} 小時",
  "report.day.newVocabulary": "新單字",
  "report.day.noVocabulary": "這天沒有新單字",
  "report.day.close": "關閉當日詳情",

  "report.weekly.title": "每週練習張數",
  "report.weekly.empty": "這段期間沒有練習紀錄",
  "report.weekly.previousPeriod": "前六週",
  "report.weekly.nextPeriod": "後六週",
  "report.weekly.barA11y": "{range}：{count} 張",
  "report.weekly.slideOne": "張",
  "report.weekly.slideOther": "張",
  "report.weekly.totalPrefix": "累計練習 ",
  "report.weekly.totalSuffix": " 張",

  "report.lessons.title": "課程分數",
  "report.lessons.empty": "這裡還沒有內容",
  "report.lessons.itemCountOne": "{count} 項",
  "report.lessons.itemCountOther": "{count} 項",
  "report.lessons.lessonCountOne": "{count} 課",
  "report.lessons.lessonCountOther": "{count} 課",
  "report.lessons.slidesDone": "已完成 {done} / {total} 張",
  "report.lessons.averageScore": "平均 {score}",
  "report.lessons.back": "返回",

  "selfStudy.title": "自主學習紀錄",
  "selfStudy.pickClassroom": "選擇班級，查看學生自己練習的情況。",
  "selfStudy.classroomCaption": "點開資料夾，查看全班各課的表格。",
  "selfStudy.lessons.title": "課程",
  "selfStudy.loadError": "無法載入這個班級的課程。",
  "selfStudy.noAccount": "尚未登入過",
  "selfStudy.progress.label": "全班紀錄",
  "selfStudy.progress.empty": "這個班級還沒有學生。",
  "selfStudy.progress.loadError": "無法載入這些紀錄。",
  "selfStudy.table.student": "學生",
  "selfStudy.table.total": "總計",
  "selfStudy.table.open": "全班表格",
  "selfStudy.band.strong": "良好",
  "selfStudy.band.mixed": "普通",
  "selfStudy.band.weak": "待加強",
  "selfStudy.band.notStarted": "未開始",

  "readonly.notScored": "尚未評分",
  "readonly.correct": "正確答案：{answer}",
  "readonly.yourAnswer": "你的答案",
  "readonly.feedback": "回饋",
  "readonly.playClip": "播放{label}",
  "readonly.stopClip": "停止播放{label}",
  "readonly.clipUnavailable": "{label}無法播放",
  "readonly.unsupported": "無法顯示這一張的細節。",
  "readonly.myRecording": "我的錄音",
  "readonly.myRecordingUnavailable": "我的錄音無法播放",
  "readonly.myReading": "我的朗讀",
  "readonly.myTurn": "我的回應",
  "readonly.myAnswer": "我的答案",
  "readonly.correctAnswer": "正確答案",
  "readonly.wordImage": "單字圖片",
  "readonly.perWord": "逐字分數",
  "readonly.promptImage": "題目圖片",
  "readonly.promptVideo": "題目影片",
  "readonly.passageImage": "文章圖片",
  "readonly.passageVideo": "文章影片",
  "readonly.passageNotSet": "找不到這段文章",
  "readonly.noParagraphs": "這次朗讀沒有紀錄任何段落。",
  "readonly.paragraph": "第 {number} 段",
  "readonly.quiz": "測驗",
  "readonly.theSound": "這個音",
  "readonly.playTheSound": "播放這個音",
  "readonly.stopTheSound": "停止播放這個音",
  "readonly.playMySoundRecording": "播放我唸 {phoneme} 的錄音",
  "readonly.stopMySoundRecording": "停止播放我唸 {phoneme} 的錄音",
  "readonly.options": "選項",
  "readonly.whatYouTyped": "你輸入的答案",
  "readonly.theClip": "這段影音",
  "readonly.noCheckpoints": "沒有紀錄任何檢核點的答案。",
  "readonly.questionNotSet": "找不到這個問題",
  "readonly.answer": "答案",
  "readonly.conversation": "對話",
  "readonly.noTurns": "這次對話沒有紀錄任何回應。",
  "readonly.assessment": "評量",
  "readonly.dimension.grammar": "文法",
  "readonly.dimension.wordChoice": "用詞",
  "readonly.dimension.understanding": "理解力",
  "readonly.dimension.communication": "溝通力",
  "readonly.dimension.pronunciation": "發音",
  "readonly.noCanvasAnswers": "這個活動沒有紀錄詳細答案。",
  "readonly.noWriting": "這次練習沒有儲存任何書寫紀錄。",
  "readonly.wordNumber": "第 {number} 個字",
  "readonly.writingOf": "{text} 的書寫",
  "error.accessLocked": "此帳號已暫停使用，請聯絡管理員。",
  "error.rateLimited": "請求次數過多，請稍候再試。",
  "error.rateLimitedMinutes": "請求次數過多，請於約 {minutes} 分鐘後再試。",
  "readonly.yourWriting": "你的書寫",
};
